import { isYmmAvailable } from '../../../../support/pages/recalls-details/recalls-util';
import { VehicleSelectorTabsLabels } from '../vehicle-selector-tabs';

function getTabsArrayForRecallModule(
    isVinTabLabelDesktop: string | undefined,
    vin: Function,
    isYmTabLabelDesktop: string | undefined,
    serverContext: any,
    ymm: Function,
    isGarageTabLabel: string | undefined,
    garage: Function
) {
    const tabsArray = [];

    if (isVinTabLabelDesktop) {
        tabsArray.push(vin());
    }
    if (
        isYmTabLabelDesktop &&
        isYmmAvailable(
            serverContext.currentLanguageRegionCode,
            serverContext.brand
        )
    ) {
        tabsArray.push(ymm());
    }
    if (isGarageTabLabel) {
        tabsArray.push(garage());
    }
    return tabsArray;
}

function getTabsArrayForOwnerManualModule(
    isVinTabLabelDesktop: string | undefined,
    vin: Function,
    isYmTabLabelDesktop: string | undefined,
    ymm: Function,
    isGarageTabLabel: string | undefined,
    garage: Function,
    ownerManualVinRedirectData: any
) {
    const tabsArray = [];
    if (isVinTabLabelDesktop) {
        tabsArray.push(vin(ownerManualVinRedirectData));
    }
    if (isYmTabLabelDesktop) {
        tabsArray.push(ymm());
    }
    if (isGarageTabLabel) {
        tabsArray.push(garage(ownerManualVinRedirectData));
    }
    return tabsArray;
}

function getTabsArrayForSyncMapsModule(
    isVinTabLabelDesktop: string | undefined,
    vin: Function,
    isGarageTabLabel: string | undefined,
    garage: Function
) {
    const tabsArray = [];
    if (isVinTabLabelDesktop) {
        tabsArray.push(vin());
    }
    if (isGarageTabLabel) {
        tabsArray.push(garage());
    }
    return tabsArray;
}

function getTabsArrayForDefault(
    isVinTabLabelDesktop: string | undefined,
    vin: Function,
    isYmTabLabelDesktop: string | undefined,
    ymm: Function
) {
    const tabsArray = [];
    if (isVinTabLabelDesktop) {
        tabsArray.push(vin());
    }
    if (isYmTabLabelDesktop) {
        tabsArray.push(ymm());
    }
    return tabsArray;
}

export const generateTabsArray = (
    redirectDataId: string,
    content: VehicleSelectorTabsLabels,
    serverContext: any,
    vin: Function,
    ymm: Function,
    garage: Function,
    ownerManualVinRedirectData?: any
) => {
    const isVinTabLabelDesktop = content?.vinTabLabelDesktop;
    const isGarageTabLabel = content?.garageTabLabel;
    const isYmTabLabelDesktop = content?.ymTabLabelDesktop;

    switch (redirectDataId) {
        case 'recalls':
        case 'recalls-details':
            return getTabsArrayForRecallModule(
                isVinTabLabelDesktop,
                vin,
                isYmTabLabelDesktop,
                serverContext,
                ymm,
                isGarageTabLabel,
                garage
            );
        case 'owner-manual':
        case 'owner-manual-details':
            return getTabsArrayForOwnerManualModule(
                isVinTabLabelDesktop,
                vin,
                isYmTabLabelDesktop,
                ymm,
                isGarageTabLabel,
                garage,
                ownerManualVinRedirectData
            );
        case 'sync-maps':
            return getTabsArrayForSyncMapsModule(
                isVinTabLabelDesktop,
                vin,
                isGarageTabLabel,
                garage
            );
        default:
            return getTabsArrayForDefault(
                isVinTabLabelDesktop,
                vin,
                isYmTabLabelDesktop,
                ymm
            );
    }
};
